import { useForm } from 'react-hook-form'
import { useState } from 'react'
import useAuth from '../../hooks/useAuth'

export interface LoginForm {
  email: string
  password: string
}

const useLoginForm = () => {
  const { handleSubmit, register, reset } = useForm<LoginForm>()
  const { login, findRedirectUrl } = useAuth()
  const [loginErrorMessage, setLoginErrorMessage] = useState('')

  const emailRegister = register('email', {
    required: '이메일을 입력해 주세요.',
  })

  const passwordRegister = register('password', {
    required: '비밀번호를 입력해 주세요.',
  })

  const onSubmit = handleSubmit(async (form: LoginForm) => {
    try {
      setLoginErrorMessage('')
      await login(form, findRedirectUrl())
    } catch {
      // 원인(아이디·비밀번호·잠김·사용 중지)을 구분하지 않는다(ISMS #98)
      setLoginErrorMessage('로그인에 실패했습니다.\n계속 실패하면 마스터 관리자에게 문의해 주세요.')
      reset()
    }
  })

  return {
    onSubmit,
    emailRegister,
    passwordRegister,
    loginErrorMessage,
  }
}

export default useLoginForm
